<template>
  <div id="footer" class="container-fluid">
    <div class="footer-left">
      <div class="logo">
        <img src="@/assets/img/logo.png" alt="logo图" />
      </div>
      <p class="copy" style="margin-top: 10px">
        紧固达客户服务热线：0310-6680008
      </p>
    </div>
    <div class="footer-right">
      <div id="map" class="wow zoomIn"></div>

      <p class="copy" style="margin-top: 10px">
        Copyright&nbsp; &copy;&nbsp; 2025 -
        {{ new Date().getFullYear() }}
        &nbsp;邯郸运创供应链管理有限公司&nbsp;&nbsp;版权所有
      </p>
      <p class="copy">备案号：冀ICP备2023026979号</p>
    </div>
    <!-- <div class="logo">
      <img src="@/assets/img/logo.png" alt="logo图">
    </div>
    <p class="address_tel_fax">
      <span>地址：公司地址</span>
      <span>Tel：888-888-888</span>
    </p>
    <p class="email_wx">
      <span>邮箱：xxx@163.com</span>
      <span>微信号：xxx</span>
    </p> -->
  </div>
</template>
<script>
import { WOW } from "wowjs";
import BMap from "BMap";
export default {
  name: "Footer",
  data() {
    return {};
  },
  mounted() {
    var map = new BMap.Map("map"); // 创建地图实例
    var point = new BMap.Point(114.528316, 36.823612); // 创建点坐标
    map.centerAndZoom(point, 15); // 初始化地图，设置中心点坐标和地图级别
    map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
    var marker = new BMap.Marker(point); // 创建标注
    map.addOverlay(marker); // 将标注添加到地图中
    // var opts = {
    //   width: 50, // 信息窗口宽度
    //   height: 10, // 信息窗口高度
    //   title: "紧固达物流园区" // 信息窗口标题
    // };
    // var infoWindow = new BMap.InfoWindow(
    //   "地址",
    //   opts
    // ); // 创建信息窗口对象
    // map.openInfoWindow(infoWindow, map.getCenter()); // 打开信息窗口
    var wow = new WOW();
    wow.init();
  },
};
</script>
<style scoped>
#footer {
  padding: 30px 160px 0 160px;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
  display: flex;
  justify-content: space-between;
}

/* .logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
} */

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: opx 0 10px;
  text-align: left;
}

#map {
  width: 450px;
  height: 150px;
}

.row {
  margin-right: 0;
  margin-left: 0;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {
    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue